module.exports = __webpack_public_path__ + "img/waist.2b8151fd.png";